export const zh = {
  common: {
    brand: 'InChi Solutions Pvt Ltd',
    brandShort: 'InChi Solutions Hub',
    openMenu: '打开菜单',
    closeMenu: '关闭菜单',
    goToSlide: '前往第 {{n}} 张幻灯片',
    viewStory: '查看案例 {{n}}',
  },
  header: {
    home: '首页',
    jobMarketplace: '招聘市场',
    services: '服务',
    clientPortal: '客户门户',
    tradeNetwork: '贸易网络',
    successStories: '成功案例',
    erp: '人力资源与薪资 ERP',
    login: '登录',
    logout: '退出',
    getStarted: '立即开始',
    langEn: 'EN',
    langZh: '中文',
  },
  footer: {
    tagline:
      '精准合作伙伴。通过全面的人力资源解决方案、全球贸易网络与工程卓越，助力企业转型升级。',
    services: '服务',
    company: '公司',
    resources: '资源',
    legal: '法律',
    hrSolutions: '人力资源解决方案',
    jobMarketplace: '招聘市场',
    tradeNetwork: '贸易网络',
    engineeringServices: '工程服务',
    aboutUs: '关于我们',
    successStories: '成功案例',
    clientPortal: '客户门户',
    contact: '联系我们',
    blog: '博客',
    caseStudies: '案例研究',
    marketReports: '市场报告',
    careerGuide: '职业指南',
    privacyPolicy: '隐私政策',
    termsOfService: '服务条款',
    cookiePolicy: 'Cookie 政策',
    compliance: '合规',
    copyright: '© {{year}} InChi Solutions Hub. 保留所有权利。',
    location: '印度班加罗尔',
    isoCertified: 'ISO 9001:2015 认证',
  },
  home: {
    seo: {
      title: 'INCHI Solutions Hub - 精准合作伙伴 | 人力资源、贸易与工程卓越',
      description:
        '与 InChi Solutions Pvt Ltd 一起转型业务——全面的人力资源服务、全球贸易网络与工程解决方案。880+ 项目、678+ 客户、112 项行业认可。您值得信赖的业务增长伙伴。',
      keywords:
        '人力资源解决方案, 人才招聘, 招聘市场, 全球贸易网络, 工程服务, 商业合作, 招聘服务, 供应商网络',
    },
    hero: {
      isoBadge: 'ISO 9001:2015 认证',
      scheduleConsultation: '预约咨询',
      clientSatisfaction: '客户满意度',
      slides: [
        {
          title: '精准合作伙伴',
          subtitle: '将业务挑战转化为高效解决方案',
          description:
            '您值得信赖的全面人力资源解决方案、全球贸易网络与工程卓越合作伙伴。已有 678+ 家机构与我们携手取得成功。',
          imageAlt: '专业商务团队在明亮的企业办公室中协作',
          cta: '探索服务',
          statsLabel: '已完成项目',
        },
        {
          title: '您的成功，我们的专长',
          subtitle: '全球网络，本地洞察',
          description:
            '获取世界级人才、国际贸易机遇与量身定制的工程解决方案。体验一体化服务带来的强大力量。',
          imageAlt: '国际商务人士在日落时分的现代玻璃办公楼中协作',
          cta: '寻找人才',
          statsLabel: '服务机构',
        },
        {
          title: '创新与可靠并重',
          subtitle: '今日铸就明日的成功故事',
          description:
            '从初创企业扩张到企业级转型，我们交付驱动增长的解决方案。了解行业领袖为何信赖 InChi Solutions Pvt Ltd。',
          imageAlt: '充满活力的商务团队在现代创业办公室庆祝成功',
          cta: '查看成功案例',
          statsLabel: '行业认可',
        },
      ],
    },
    stats: {
      badge: '卓越业绩',
      title: '用数字说话',
      subtitle: '我们对卓越的承诺体现在每一项指标中。加入日益壮大的成功合作伙伴社区。',
      items: [
        {
          label: '已完成项目',
          description: '跨行业成功交付',
        },
        {
          label: '服务机构',
          description: '从初创到世界500强',
        },
        {
          label: '行业认可',
          description: '卓越获全球认可',
        },
        {
          label: '成功安置专业人才',
          description: '助力职业转型',
        },
      ],
      satisfaction: '客户满意度',
      support: '全天候支持',
      response: '平均响应时间',
    },
    services: {
      badge: '全方位解决方案',
      title: '一站式商业合作伙伴',
      subtitle:
        '从人才招聘到全球贸易，我们提供推动业务前进的一体化服务。体验统一解决方案的力量。',
      explore: '了解服务',
      viewAll: '查看全部服务',
      items: [
        {
          title: '人力资源解决方案与人才招聘',
          description:
            '从招聘到留任的端到端人力资源管理。接入我们丰富的人才库与高效招聘流程。',
          imageAlt: '专业人力资源经理在现代玻璃墙办公室中面试候选人',
          features: ['高管寻访', '批量招聘', '薪资管理', '培训与发展'],
        },
        {
          title: '招聘市场',
          description:
            '连接顶尖雇主，发现跨行业职业机遇。智能匹配算法确保岗位与候选人完美契合。',
          imageAlt: '年轻职业女性在明亮的现代联合办公空间中浏览职位',
          features: ['智能职位匹配', '公司简介', '申请跟踪', '职业资源'],
        },
        {
          title: '全球贸易网络',
          description:
            '借助我们值得信赖的供应商网络与跨洲贸易促进服务，拓展国际业务。',
          imageAlt: '繁忙港口码头的国际集装箱、货轮与起重机',
          features: ['供应商寻源', '贸易合规', '物流支持', '市场情报'],
        },
        {
          title: '工程服务',
          description:
            '面向复杂项目的专业工程解决方案。从设计到实施，我们交付技术卓越。',
          imageAlt: '工程团队在现代工业设施中分析技术蓝图与 CAD 设计',
          features: ['项目管理', '技术咨询', '质量保证', '创新实验室'],
        },
      ],
    },
    stories: {
      badge: '客户成功案例',
      title: '化挑战为胜利',
      subtitle: '真实合作，真实成果。了解我们如何助力各行业企业实现目标。',
      challenge: '挑战',
      solution: '方案',
      result: '成果',
      viewAll: '查看全部案例',
      items: [
        {
          company: 'TechVision Solutions',
          industry: '信息技术',
          logoAlt: '现代科技公司办公室，玻璃墙与蓝白配色当代设计',
          challenge: '快速扩张需在 6 个月内招聘 200+ 技术人才',
          solution: '实施端到端招聘策略，并建立专属人才库',
          result: '成功安置 215 名专业人才，留任率达 95%',
          metrics: [
            { label: '已填补岗位', value: '215' },
            { label: '节省时间', value: '40%' },
            { label: '留任率', value: '95%' },
          ],
          testimonial:
            'InChi Solutions Pvt Ltd 彻底改变了我们的招聘流程。他们对技术人才的理解与高效流程，帮助我们以超乎想象的速度实现扩张。',
          author: 'Rajesh Kumar',
          position: '首席技术官',
          imageAlt: '身着正装的印度男性高管在现代企业办公室自信微笑',
        },
        {
          company: 'Global Manufacturing Corp',
          industry: '制造与工程',
          logoAlt: '配备现代机械与自动化产线的洁净工厂环境',
          challenge: '需要可靠的国际供应商提供关键零部件',
          solution: '借助全球贸易网络识别并审核 50+ 家供应商',
          result: '采购成本降低 30%，同时提升质量标准',
          metrics: [
            { label: '成本降低', value: '30%' },
            { label: '已审核供应商', value: '50+' },
            { label: '质量提升', value: '25%' },
          ],
          testimonial:
            'NCHI 提供的贸易网络专业能力极具价值。他们为我们对接可靠供应商，并无缝处理所有合规复杂性。',
          author: 'Priya Sharma',
          position: '采购负责人',
          imageAlt: '身着优雅商务套装的印度女性商业领袖在明亮办公室审阅文件',
        },
        {
          company: 'RetailMax India',
          industry: '零售与电子商务',
          logoAlt: '明亮照明与有序商品陈列的现代零售店内景',
          challenge: '全国 15 个门店的季节性用工管理',
          solution: '制定灵活用工模式并配套培训计划',
          result: '旺季运营效率提升 45%',
          metrics: [
            { label: '效率提升', value: '45%' },
            { label: '服务门店', value: '15' },
            { label: '已培训员工', value: '500+' },
          ],
          testimonial:
            'NCHI 的灵活用工方案与全面培训计划，彻底改变了我们的季节性运营。强烈推荐！',
          author: 'Amit Patel',
          position: '运营总监',
          imageAlt: '留着胡子、身着商务休闲装的印度男性经理在零售环境中温暖微笑',
        },
      ],
    },
    trust: {
      badge: '值得信赖的卓越',
      title: '认证品质，验证成果',
      subtitle: '我们对卓越的承诺以行业认证为支撑，并获得全球领先机构的信任。',
      trustedBy: '受行业领袖信赖',
      clientsSay: '客户评价',
      certifications: [
        { title: 'ISO 9001:2015', description: '质量管理' },
        { title: '行业领袖', description: '112 项认可' },
        { title: '数据安全', description: 'GDPR 合规' },
        { title: '认证伙伴', description: '可信网络' },
      ],
      testimonials: [
        {
          text: 'InChi Solutions Pvt Ltd 对我们的增长至关重要。他们在人才招聘方面的专长帮助我们组建了世界级团队。',
          author: 'Vikram Mehta',
          position: '首席执行官，TechVision',
          imageAlt: '身着正装的印度男性首席执行官在行政办公室展现自信神情',
        },
        {
          text: '全球贸易网络为我们打开了意想不到的大门。服务出色，合作可靠。',
          author: 'Anita Desai',
          position: '董事，Global Trade Co',
          imageAlt: '身着优雅商务装的印度女性董事在现代企业环境中温暖微笑',
        },
        {
          text: '从招聘到留任，NCHI 无缝处理一切。他们是我们成功的真正伙伴。',
          author: 'Rahul Kapoor',
          position: '人力资源负责人，Innovation Labs',
          imageAlt: '身着商务休闲装、态度友好的男性人力资源高管在现代办公室',
        },
      ],
    },
    cta: {
      title: '准备好转型您的业务了吗？',
      subtitle:
        '已有 678+ 家机构信赖 InChi Solutions Pvt Ltd。今天就开始您的成功之旅。',
      startPartnership: '开启合作',
      clientPortal: '客户门户',
      getStarted: '立即开始',
      actions: [
        {
          title: '找到理想工作',
          description: '浏览海量机会',
        },
        {
          title: '招聘顶尖人才',
          description: '接入我们的人才库',
        },
        {
          title: '拓展全球业务',
          description: '对接全球供应商',
        },
        {
          title: '获取咨询',
          description: '与专家交流',
        },
      ],
      isoTitle: 'ISO 9001:2015 认证',
      isoDesc: '卓越质量管理',
      supportTitle: '全天候支持',
      supportDesc: '随时为您服务',
      recognitionTitle: '行业认可',
      recognitionDesc: '112 项奖项持续增长',
    },
  },
};
